import {useState, useEffect} from 'react'
import {useUsid, useShopperContext} from '@salesforce/commerce-sdk-react'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {useUpdateShopperContext} from './use-update-shopper-context'
import {useLocaleCountry} from './use-locale-custom'

const useCorporateBanner = () => {
    const [showCorporateBanner, setShowCorporateBanner] = useState(false)
    const {site} = useMultiSite()
    const {usid} = useUsid()
    const currentCountry = useLocaleCountry()

    const {data: shopperContext} = useShopperContext(
        {parameters: {usid, siteId: site.id}},
        {enabled: true},
    )
    // Ensure sourceCode is handled appropriately without direct assignment
    useEffect(() => {
        // Check if sourceCode exists in the shopper context
        const hasSourceCode = Boolean(shopperContext?.sourceCode)
        setShowCorporateBanner(hasSourceCode)
    }, [shopperContext])

    const updateShopperContext = useUpdateShopperContext()

    const exitSource = async () => {
        try {
            // Remove cluid from localStorage
            localStorage.removeItem('cluid')

            // Update shopper context to remove source code
            const newShopperContext = {
                customQualifiers: {
                    countryCode: currentCountry,
                    isCorporate: false,
                },
                sourceCode: '',
            }

            // Wait for the context update to complete
            await updateShopperContext.mutateAsync(newShopperContext)

            // Only update UI state after successful context update
            setShowCorporateBanner(false)
        } catch (error) {
            console.error('Failed to update shopper context:', error)
        }
    }

    return {
        showCorporateBanner,
        exitSource,
    }
}

export default useCorporateBanner
